import PropTypes from "prop-types";
import React from "react";
import "./VehicleSpeedDisplay.css";
import SpeedGauge from "@components/VehicleDashboard/speedGauge/SpeedGauge.js";

export default function VehicleSpeedDisplay({ value, label, unit, denominator }) {
  const isPercentage = unit === "%" && value < 20;
  const valueClass = isPercentage ? "low-value" : "";

  const formattedValue = value >= 1000 ? `${(value / 1000).toFixed(1)}k` : value.toFixed(1);
  const displayedValue = label === "Fuel" ? value : formattedValue;
  const displayedDenominator = denominator != null ? `/${denominator.toFixed(1)}` : "";

  return (
    <div className="speed-display">
      <div className="speed-content">
        <div className="speed-label">{label}</div>
        <SpeedGauge value={value} denominator={denominator} />
        {/* <div className={`speed-value ${valueClass}`}>{displayedValue}{displayedDenominator}</div> */}
        <div className="unit">{unit}</div>
      </div>
    </div>
  );
}

VehicleSpeedDisplay.propTypes = {
  value: PropTypes.number.isRequired,
};
